import { report } from "process";

const initialState = {
  searchTerm: '',
  status: {
    text: 'Filter By Status',
    filter: ""
  },
  reportType: {
    text: 'Filter By Type',
    filter: ""
  },
  company: {
    text: 'Filter By Company',
    filter: "__ALL"
  },
  companySearchTerm: '',
  companies: [],
  reload: false
};


export default {
  state: Object.assign({}, initialState),
  mutations: {
    setReportFeedSearchTerm: (state, searchTerm) => {
      state.searchTerm = searchTerm;
    },
    setReportFeedStatus: (state, status) => {
      state.status = status;
    },
    setReportFeedReportType: (state, reportType) => {
      state.reportType = reportType;
    },
    setReportFeedReload: (state, reload) => {
      state.reload = reload;
    },
    setReportFeedCompanyFilter: (state, companyFilter) => {
      state.company = companyFilter;
    },
    setReportFeedCompanies: (state, companies) => {
      state.companies = companies;
    },
    setReportFeedCompanySearchTerm: (state, searchTerm) => {
      state.companySearchTerm = searchTerm;
    }
  },
};
